// "Evénements et expositions mycologiques" - the only tag that gets the
// event-metadata control (see extend.php's `event` field on
// DiscussionResource, gated to this same id server-side once a discussion
// exists). No sub-tags, so no need for a taxonGroups.js-style id->group map.
export const EVENTS_TAG_ID = 1000034;

// Its required primary parent ("Champignons") - hardcoded rather than read
// off `Tag.parent()`, since GET /api/tags/{id} doesn't inline the parent
// resource (no `included` section, only a bare relationship identifier) -
// `.parent()` would need it to already be cached in the store from some
// earlier, unrelated fetch. Used by UpcomingEvents.tsx to pre-select both
// tags when starting a new event (minPrimaryTags=1 makes the parent
// mandatory alongside the child).
export const EVENTS_PARENT_TAG_ID = 1000017;
export function hasEventsTag(tags) {
  return (tags || []).some(t => t && String(t.id()) === String(EVENTS_TAG_ID));
}
flarum.reg.add('champis-events', 'forum/utils/eventsTag', { EVENTS_TAG_ID: EVENTS_TAG_ID,EVENTS_PARENT_TAG_ID: EVENTS_PARENT_TAG_ID,hasEventsTag: hasEventsTag, });